import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23c76edc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "產生圖像中...", -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "ion-text-center" }
const _hoisted_5 = { style: {"margin-top":"50px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_v_image = _resolveComponent("v-image")!
  const _component_v_layer = _resolveComponent("v-layer")!
  const _component_v_text = _resolveComponent("v-text")!
  const _component_v_rect = _resolveComponent("v-rect")!
  const _component_v_stage = _resolveComponent("v-stage")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return ($setup.loadingCanvas)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_spinner),
        _hoisted_2
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "secondary",
                  shape: "round",
                  fill: "outline",
                  onClick: $setup.shareCanvasImg
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 分享尋寵啟事 "),
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      icon: $setup.shareSocialOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openImageModal($setup.getCanvasDataURL())))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "icon-only",
                      icon: $setup.expand
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_stage, {
          ref: "stageRef",
          config: { width: $setup.sceneWidth, height: $setup.sceneHeight }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_layer, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_image, {
                  config: {
          width: $setup.sceneWidth,
          height: $setup.sceneHeight,
          x: 0,
          y: 0,
          image: $setup.canvas.bgImg,
          preventDefault: false,
        }
                }, null, 8, ["config"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_layer, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_image, {
                  config: {
          scaleX: Math.min(75 / $setup.canvas.petImg.naturalWidth, 200 / $setup.canvas.petImg.naturalHeight),
          scaleY: Math.min(75 / $setup.canvas.petImg.naturalWidth, 200 / $setup.canvas.petImg.naturalHeight),
          x: $setup.sceneWidth / 2 - 75 / 2,
          y: $setup.sceneHeight / 2 - 120,
          image: $setup.canvas.petImg
        }
                }, null, 8, ["config"]),
                _createVNode(_component_v_text, {
                  config: {
            x: 25,
            y: $setup.sceneHeight / 2 + 30,
            width: $setup.sceneWidth / 2,
            height: $setup.canvas.fontSize,
            text: `名字：${$setup.userPet.lostPetPosterName}`,
            fontSize: $setup.canvas.fontSize,
            verticalAlign: 'middle',
            fontFamily: 'Calibri',
          }
                }, null, 8, ["config"]),
                _createVNode(_component_v_text, {
                  config: {
            x: $setup.sceneWidth / 2,
            y: $setup.sceneHeight / 2 + 30,
            width: $setup.sceneWidth / 2,
            height: $setup.canvas.fontSize,
            text: `品種：${$setup.userPet.lostPetPosterBreed}`,
            fontSize: $setup.canvas.fontSize,
            verticalAlign: 'middle',
            fontFamily: 'Calibri',
          }
                }, null, 8, ["config"]),
                _createVNode(_component_v_text, {
                  config: {
            x: 25,
            y: $setup.sceneHeight / 2 + 55,
            width: $setup.sceneWidth,
            height: $setup.canvas.fontSize,
            text: `年齡：${$setup.getPetAge($props.pet.dateOfBirth)} (${$props.pet.gender == 'male' ? '男' : '女'}${$props.pet.color ? ' / ' + $props.pet.color : ''})`,
            fontSize: $setup.canvas.fontSize,
            verticalAlign: 'middle',
            fontFamily: 'Calibri',
          }
                }, null, 8, ["config"]),
                _createVNode(_component_v_text, {
                  config: {
            x: 25,
            y: $setup.sceneHeight / 2 + 80,
            width: $setup.posterContentWidth,
            height: $setup.canvas.fontSize,
            text: `走失地點：${$setup.userPet.lostLocation}`,
            fontSize: $setup.canvas.fontSize,
            verticalAlign: 'middle',
            fontFamily: 'Calibri',
          }
                }, null, 8, ["config"]),
                _createVNode(_component_v_text, {
                  config: {
            x: 25,
            y: $setup.sceneHeight / 2 + 105,
            width: $setup.posterContentWidth,
            height: $setup.canvas.fontSize,
            text: `特徵：${$setup.userPet.remarkFeatures}`,
            fontSize: $setup.canvas.fontSize,
            verticalAlign: 'middle',
            fontFamily: 'Calibri',
          }
                }, null, 8, ["config"]),
                _createVNode(_component_v_rect, {
                  config: {
          x: 45,
          y: $setup.sceneHeight - 65,
          width: $setup.posterContentWidth - 45,
          height: 50,
          fill: '#E41D3E',
        }
                }, null, 8, ["config"]),
                _createVNode(_component_v_text, {
                  config: {
            x: 20,
            y: $setup.sceneHeight - 60,
            width: $setup.posterContentWidth,
            height: 20,
            text: `聯絡電話：${$setup.userPet.contactPersonPhone}`,
            fontSize: 20,
            align: 'center',
            verticalAlign: 'middle',
            fontFamily: 'Calibri',
            fill: 'white',
          }
                }, null, 8, ["config"]),
                _createVNode(_component_v_text, {
                  config: {
            x: 20,
            y: $setup.sceneHeight - 38,
            width: $setup.posterContentWidth,
            height: 20,
            text: `${$setup.userPet.contactPersonName}`,
            fontSize: 20,
            align: 'center',
            verticalAlign: 'middle',
            fontFamily: 'Calibri',
            fill: 'white',
          }
                }, null, 8, ["config"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["config"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ion_button, {
            color: "secondary",
            shape: "round",
            onClick: $setup.saveCanvasImg
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 儲存尋寵啟事圖片 "),
              _createVNode(_component_ion_icon, {
                slot: "end",
                icon: $setup.downloadOutline
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_ion_list, { style: {"padding-top":"0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, { fill: "outline" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode("寵物名字")
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  type: "text",
                  modelValue: $setup.userPet.lostPetPosterName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userPet.lostPetPosterName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { fill: "outline" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode("寵物品種")
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  type: "text",
                  modelValue: $setup.userPet.lostPetPosterBreed,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.userPet.lostPetPosterBreed) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { fill: "outline" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode("走失地點")
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  type: "text",
                  modelValue: $setup.userPet.lostLocation,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.userPet.lostLocation) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { fill: "outline" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode("特徵描述")
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_textarea, {
                  modelValue: $setup.userPet.remarkFeatures,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.userPet.remarkFeatures) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { fill: "outline" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode("聯絡電話")
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  type: "text",
                  modelValue: $setup.userPet.contactPersonPhone,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.userPet.contactPersonPhone) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { fill: "outline" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode("聯絡人名字")
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  type: "text",
                  modelValue: $setup.userPet.contactPersonName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.userPet.contactPersonName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ion_toolbar, { class: "ion-text-center fixed-bottom" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.syncPosterInfoToUserPet())),
                expand: "block"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('save')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]))
}